import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { ISendToPCToPrintParams, ISendToPCToViewParams, ISendToPcExtension } from './interface';

export async function sendToPCToView(params?: ISendToPCToViewParams) {
    const extension = await ArkLoader.extensionService.getExtension<ISendToPcExtension>(componentConfig.name);
    extension.sendToPCToView(params);
}

export async function sendToPCToPrint(params?: ISendToPCToPrintParams) {
    const extension = await ArkLoader.extensionService.getExtension<ISendToPcExtension>(componentConfig.name);
    extension.sendToPCToPrint(params);
}

export async function sendToDeviceToPrint() {
    const extension = await ArkLoader.extensionService.getExtension<ISendToPcExtension>(componentConfig.name);
    extension.sendToDeviceToPrint();
}

